import {
    BuyingPowerServiceClient,
    ListBuyingPowerRequest,
  } from '../proto/marginpb/buyingpower_grpc_web_pb';
  import { auth } from '../lib/auth/Auth';
  import { stringToProtoDate } from './ConvertService';
  import { Pagination } from '../proto/utilspb/pagination_pb';
  
  const service = new BuyingPowerServiceClient(
    window.env.GRPC_ENDPOINT,
    {},
    { ...auth }
  );
  
  export async function listBuyingPower(param, paging) {
    return new Promise((resolve, reject) => {
      
      const req = new ListBuyingPowerRequest();
      req.setFromDate(stringToProtoDate(param.fromDate));
      req.setToDate(stringToProtoDate(param.toDate));
      req.setCorrespondent(param.correspondent);
      req.setMasterAccountNo(param.masterAccountNo);
      req.setAccountName(param.accountName);
      req.setMarginType(param.marginType);
      req.setHideZero(param.hideZero);
  
      if (paging) {
        let pg = new Pagination();
        pg.setPageNo(paging.pageNo);
        pg.setPageSize(paging.rowsPerPage);
        pg.setSortName(paging.sortName);
        pg.setSortDirection(paging.sortDirection);
        pg.setFilterNamesList(paging.filterNames);
        pg.setFilterValuesList(paging.filterValues);
        req.setPagination(pg);
      }
  
      service.listBuyingPower(req, {}, (error, response) => {
        if (error) {
          reject(error);
        } else {
          resolve(response.toObject());
        }
      });
    });
  }
  
 
  